import React from 'react'
import PropTypes from 'prop-types'
import AppIcon from '../../../../../Assets/icons/icono-app.svg'
import WebIcon from '../../../../../Assets/icons/icono-web.svg'
import TlajoChatIcon from '../../../../../Assets/icons/icono-tlajochat.svg'

const ReportsChanel = ({
  channel_capture,
  category_name,
  img,
  sub_category_name,
  img_sub_category,
}) => {
  const webChannels = ['web', 'web_gestor', 'web_anonymous']
  return (
    <div className="reports-channel ">
      <div className="category-icon">
        <img src={img} alt="Category Icon" className="mr-2" />
      </div>
      <div className="hover-content">
        {/* <h5>Categoría</h5> */}
        {/* <hr /> */}
        <div>
          <div>{category_name}</div>
          {/* <hr />
          <div className="reports-sub-category d-flex">
            <div className="sub-category-icon d-flex align-items-center">
              <img
                src={img_sub_category}
                alt="SubCategory Icon"

                // className="mr-2"
              />
              <div className="mr-4">&nbsp;{sub_category_name}</div>
            </div>
          </div> */}
        </div>
      </div>

      <div className="category-icon">
        <img src={img_sub_category} alt="SubCategory Icon" />
      </div>
      <div className="hover-content">
        <div>
          <div>{sub_category_name}</div>
        </div>
      </div>

      <div className="channel-icon">
        <img
          src={
            channel_capture === 'app'
              ? AppIcon
              : webChannels.includes(channel_capture)
              ? WebIcon
              : TlajoChatIcon
          }
          alt="Dog Icon"
          className="mr-2"
        />
      </div>
      <div className="hover-content-2">
        {/* <h5>Canal</h5> */}
        {/* <hr /> */}
        <div>
          <div>
            {channel_capture === 'app'
              ? 'App'
              : webChannels.includes(channel_capture)
              ? 'Web'
              : 'TlajoChat'}
          </div>
        </div>
      </div>
    </div>
  )
}

ReportsChanel.propTypes = {
  category: PropTypes.string.isRequired,
  channel_capture: PropTypes.oneOf([
    'app',
    'web',
    'web_gestor',
    'web_anonymous',
    'tlajochat',
  ]).isRequired,
}

export default ReportsChanel
